import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Calendar as CalendarIcon } from '@livingdesign/icons';
import { Trans, useTranslation } from 'react-i18next';
import {
  Body,
  Caption,
  Card,
  Grid,
  ProgressIndicator
} from '@walmart-web/livingdesign-components';
import _random from 'lodash/random';

import styles from './styles.module.css';
import ProductActivityStatusLogo, {
  logoTypes
} from '../ProductActivityStatusLogo/index.tsx';

export type ProductTestingActivity = {
  name: string;
  projectId: string;
  shortId?: string;
  timestamp: string;
  status: number;
};

type LogoKeys = keyof typeof logoTypes;

const ProductTestingActivityCard: React.FC<ProductTestingActivity> = ({
  name,
  projectId,
  timestamp,
  status,
  shortId
}) => {
  const { t } = useTranslation('ihut');
  const logoKeys = Object.keys(logoTypes) as LogoKeys[];
  const randomIdx = _random(0, logoKeys.length - 1);
  return (
    <Link
      data-testid={`activity-card-link-${projectId}`}
      to={`/activities/product-testing/${projectId}`}
      className={styles.cardLink}
    >
      <Card UNSAFE_className={styles.card} data-testid="activity-card">
        <ProductActivityStatusLogo type={logoKeys[randomIdx]} />
        <Grid UNSAFE_className={styles.cardInfo}>
          {shortId && (
            <Caption UNSAFE_className={styles.cardId} data-testid="activity-id">
              {t('selectedActivity.id', { activityId: shortId })}
            </Caption>
          )}
          <Body
            UNSAFE_className={styles.cardHeading}
            data-testid="activity-name"
          >
            {name}
          </Body>
          <ProgressIndicator
            a11yLabelledBy={`${status} of 3 Steps`}
            value={Math.floor((status * 100) / 3)}
            variant="info"
            data-testid="activity-progress-indicator"
          />
          <Body
            size="small"
            UNSAFE_className={styles.activityStatus}
            data-testid="activity-step-status"
          >
            {t('selectedActivity.status', { current: status, total: 3 })}
          </Body>
          <Caption UNSAFE_className={styles.activityCompleteDateText}>
            <CalendarIcon className={styles.calendarIcon} />
            <Trans
              t={t}
              i18nKey="shippingInfo.completeBy"
              values={{ date: moment(timestamp).format('MM/DD/YYYY') }}
            >
              Complete by:{' '}
              <Caption UNSAFE_className={styles.activityCompleteByDate}>
                completeByDate
              </Caption>
            </Trans>
          </Caption>
        </Grid>
      </Card>
    </Link>
  );
};

export default ProductTestingActivityCard;
